module.exports = __webpack_public_path__ + "static/img/soyusach.e0dd668.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soyusach.png
// module id = AvdW
// module chunks = 1